import React from "react"

export default function MyAppointments() {


  return (
    <div>
      <h1>My Appointments</h1>
      
    </div>
  )
}
